import { render, staticRenderFns } from "./memberJoin.vue?vue&type=template&id=2cb5054a&scoped=true&"
import script from "./memberJoin.vue?vue&type=script&lang=js&"
export * from "./memberJoin.vue?vue&type=script&lang=js&"
import style0 from "./memberJoin.vue?vue&type=style&index=0&id=2cb5054a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb5054a",
  null
  
)

export default component.exports